'use client';

import React, { useEffect, useState } from 'react';
import './styles.scss';
import Button from '@/components/atoms/button';
import { FiDownload, FiFacebook, FiTwitter, FiLinkedin } from 'react-icons/fi';
import Icon from '@/components/atoms/icon';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from 'react-share';
import { WEB_URL } from '@/statics/constants';
import AntImage from '@/components/atoms/image';
import { checkDownloadStatus } from '@/services/apis/modules/plans';
import { Spin } from 'antd/lib';
import { notify } from '@/utils/funtion';
import PermissionModal from '@/components/organisms/permission-modal';
import { useSelector } from 'react-redux';
import { useUnauthorized } from '@/stores/context/unauthorized';

interface IProps {
  src: string;
  desc: string | undefined;
  id: string | undefined;
}

const DownloadThumbnail: React.FC<IProps> = ({ src, desc, id }) => {
  const { handleOpenUnauthorized } = useUnauthorized();

  const userData = useSelector((state: any) => state.userData);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    title: '',
  });

  const downloadImage = async (
    imageUrl: string,
    fileName: string = 'downloaded-image.jpg',
  ) => {
    try {
      const absoluteUrl = imageUrl.startsWith('http')
        ? imageUrl
        : `${process.env.NEXT_PUBLIC_WORDPRESS_URL}${imageUrl}`;

      const response = await fetch(
        `/api/download-image?url=${encodeURIComponent(absoluteUrl)}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Lỗi khi tải ảnh:', error);
      alert('Không thể tải ảnh. Vui lòng thử lại sau.');
    }
  };

  const handleDownloadImage = async () => {
    if (!userData?.user) {
      setModal({
        ...modal,
        title: 'Download hình dữ liệu hằng ngày',
        open: true,
      });
      return;
    }
    try {
      setLoading(true);
      const response = await checkDownloadStatus({
        type: 'article',
        groupData: 'article',
      });

      if (response?.status) {
        const { data } = response;
        if (data?.downLoadStatus) {
          await downloadImage(src, desc);
        } else {
          notify('info', 'Bạn đã hết lượt tải ảnh');
        }
      } else {
        if (response.key === 'unauthorized') {
          handleOpenUnauthorized();
        } else {
          notify('warning', 'Xảy ra lỗi khi tải ảnh', 'top-right');
        }
      }
    } catch (error) {
      console.error('Error during download:', error);
      notify('error', 'Đã xảy ra lỗi không mong muốn', 'top-right');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="m-download-thumbnail">
      <div className="m-download-thumbnail_left">
        <AntImage src={src} preview alt="download" />
      </div>
      <div className="m-download-thumbnail_right">
        <div className="m-download-thumbnail_right_decs">
          <div className="m-download-thumbnail_right_title">Mô tả:</div>
          <p>{desc}</p>
        </div>
        <Spin spinning={loading}>
          <Button
            shape="fill"
            variant="primary"
            ariaLabel="Tải xuống hình ảnh"
            disabled={loading}
            onClick={() => {
              handleDownloadImage();
            }}
          >
            <Icon component={<FiDownload />} />
            <p>Tải xuống hình ảnh</p>
          </Button>
        </Spin>
        <div className="m-download-thumbnail_right_share">
          <FacebookShareButton
            url={`${WEB_URL}/con-so-biet-noi/${id}`}
            hashtag={'#Vietstats'}
            className="m-download-thumbnail_right_share_fb"
          >
            <Icon component={<FiFacebook />} />
          </FacebookShareButton>

          <TwitterShareButton
            url={`${WEB_URL}/con-so-biet-noi/${id}`}
            title={desc}
            className="m-download-thumbnail_right_share_tw"
          >
            <Icon component={<FiTwitter />} />
          </TwitterShareButton>

          <LinkedinShareButton
            url={`${WEB_URL}/con-so-biet-noi/${id}`}
            summary={desc}
            source={WEB_URL}
            className="m-download-thumbnail_right_share_li"
          >
            <Icon component={<FiLinkedin />} />
          </LinkedinShareButton>
        </div>
      </div>
      <PermissionModal
        open={modal.open}
        onCancel={() => {
          setModal({
            title: '',
            open: false,
          });
        }}
        title={modal.title}
      />
    </div>
  );
};

export default DownloadThumbnail;
